import api from '../../../App/socket';
import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';
import { getErrorMessage } from '../../../../shared/helpers';

export const createBikeHpiCheck = (bike_id) => (
    api.send(
        {
            api: 'module',
            module: 'Leads',
            classMethod: 'GetHpiCheck',
            options:
                {
                    where:
                        {
                            // ID Fron Bike_lead
                            bike_id,
                        },
                },
        },
    )
        .then((response) => response)
        .catch((error) => error)
);


export const getBikeHpiCheck = async (bike_id) => {
    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_HPI_CHECKS}?bikeLeadId=${bike_id}`,
        });
        return {
            result: true,
            options: res.data?.[0] || null,
        };
    } catch (e) {
        return {
            msg: getErrorMessage(e),
            error: e,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/bike_hpi_check_request.js